export const SubtenantConstants = {
  defaultPageName: 'subtenants',
  defaultPageId: 'subtenants',
  typeName: 'Subtenant',
};
